<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.forms.tagName`),
      tagLink: `${searchResult.link}/forms`,
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.name,
    }"
    class="form-card result-card"
    @result-clicked="handleResultClick"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:file-pen-line"
          size="24"
          data-testid="form-card-preview-icon"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        class="title"
        data-testid="form-card-title"
        @click.stop="handleResultClick"
        >{{ searchResult.name }}</a
      >
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';
import { computed } from 'vue';

const emit = defineEmits(['result-clicked']);

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const url = computed(() => {
  return `${props.searchResult.link}/forms/${props.searchResult.id}`;
});

async function handleResultClick() {
  await navigateTo(url.value, { external: true });
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}
</script>

<style scoped>
.form-card {
  --color-green-200: #26aa80;
  --color-green-50: #f5fcfa;
  --background-color: var(--color-green-50);
  --text-color: var(--color-green-200);

  .title {
    line-height: 120%;
  }
}
</style>
